import type { FallbackRender } from '@sentry/react'

import React from 'react'
import { AlertTriangleIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Empty, EmptyDescription, EmptyHeader, EmptyMedia } from '../ui/empty'

type Props = React.ComponentProps<FallbackRender> & {
	className?: string
}
export function ErrorContentMessage({ className }: Props) {
	const { t } = useTranslation()

	return (
		<Empty className={className}>
			<EmptyHeader>
				<EmptyMedia
					variant='icon'
					className='bg-destructive/20 text-destructive'
				>
					<AlertTriangleIcon />
				</EmptyMedia>
				<EmptyDescription>{t('error.unrecoverable.title')}</EmptyDescription>
			</EmptyHeader>
		</Empty>
	)
}
